import * as actions from './actions';

const module = {
  actions,
};

export default { module };



// WEBPACK FOOTER //
// ./src/app/policies/store/index.js